import { useEffect } from "react";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { PortableText } from "@portabletext/react";
import { useGroq } from "../../lib/sanity";

const GET_PAGE = `{
  "pages": *[_type == "page" && slug.current == $slug][0...1]{
    title,
    "data": body
  }
}`;

const PageRouter = () => {
  let location = useLocation();
  const slug = location.pathname.replace(/^\//, "");
  let { loading, error, data } = useGroq<any>(GET_PAGE, { slug });

  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

  if (error) {
    toast.error(
      "Failed to establish a connection with the server. Please try again later.",
      { id: "noserverconnection", duration: Infinity }
    );
    console.error(error);
  }

  if (!loading && !error && !data?.pages?.[0]) {
    toast.error(
      "This page doesn't exist. The site is under construction, so please check back soon.",
      { id: "noserverconnection", duration: Infinity }
    );
  }

  return (
    <div className="bg-gray-900 py-24">
      <div className="max-w-3xl mx-auto">
        {!loading && !error && data?.pages?.[0] ? (
          <>
            <h1 className="px-4 sm:px-6 text-4xl md:text-6xl font-bold font-header text-white mb-8 text-center">
              {data.pages[0].title}
            </h1>
            <div className="prose-content px-4 sm:px-6">
              <PortableText value={data.pages[0].data} />
            </div>
          </>
        ) : (
          <div className="px-4 sm:px-6">
            {[...Array(5)].map((_, i) => {
              return (
                <div className="w-full" key={"paragraphskeleton" + i}>
                  <div className="w-full bg-gray-600 h-6 mb-2 animate-pulse"></div>
                  <div className="w-full bg-gray-600 h-6 mb-2 animate-pulse"></div>
                  <div className="w-full bg-gray-600 h-6 mb-2 animate-pulse"></div>
                  <div className="w-full bg-gray-600 h-6 mb-2 animate-pulse"></div>
                  <div className="w-2/3 bg-gray-600 h-6 mb-4 animate-pulse"></div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageRouter;
